export default __webpack_public_path__ + "static/media/search.ca69a20a.png";